"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.compare = compare;
// Common functions to work with strings

/**
 * 
 * Compares two strings alphabetically.
 *
 * If `reversed`, will sort with a descending order.
 */
function compare(a, b) {
    var reversed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var caseInsensitive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    var aFormatted = a;
    var bFormatted = b;
    if (caseInsensitive) {
        aFormatted = a.toLowerCase();
        bFormatted = b.toLowerCase();
    }
    if (aFormatted < bFormatted) {
        return reversed ? 1 : -1;
    } else if (aFormatted > bFormatted) {
        return reversed ? -1 : 1;
    }
    return 0;
}